import React from "react";
import { CSSProperties } from "react";

interface NumberPadProps {
  counter: number; // Counter prop
}

const NumberPad: React.FC<NumberPadProps> = ({ counter }) => {
  const isButtonLit = (buttonNumber: number): boolean => {
    if (counter >= 15) return true; // All buttons lit at counter 15 or greater
    return buttonNumber < counter - 4;
  };

  return (
    <div style={styles.padContainer}>
      {Array.from({ length: 10 }, (_, index) => (
        <div
          key={index}
          style={{
            ...styles.numberBox,
            backgroundColor: isButtonLit(index) ? "#32CD32" : "#f0f0f0", // Active: Green, Default: Light gray
            color: isButtonLit(index) ? "white" : "#333", // Active: White text, Default: Dark text
            boxShadow: isButtonLit(index)
              ? "0 4px 8px rgba(50, 205, 50, 0.3)" // Green glow for active
              : "0 2px 4px rgba(0, 0, 0, 0.1)", // Subtle shadow for default
          }}
        >
          {index}
        </div>
      ))}
    </div>
  );
};

const styles: { [key: string]: CSSProperties } = {
  padContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)", // 3 columns layout
    gap: "15px", // Space between boxes
    width: "220px", // Adjust width for better alignment
    margin: "0 auto", // Center the grid horizontally
    marginTop: "50px", // Add top spacing
  },
  numberBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "60px",
    height: "60px",
    borderRadius: "10px",
    fontSize: "1.5rem", // Larger, modern font
    fontWeight: "600", // Bold font
    cursor: "pointer", // Pointer cursor on hover
    transition: "background-color 0.3s, transform 0.2s, box-shadow 0.3s",
    userSelect: "none", // Prevent text selection
  },
};

export default NumberPad;
